import Vue from 'vue';
import router from '@/router';
import ElementUI from 'element-ui';
import VueAxios from 'vue-axios';
import { user, prevent } from '@/core/utils';
import axios, { URL , noSign} from '@/axios';
import dataObj from '@/axios/cosUploadFile';

import App from './App.vue';

Vue.config.productionTip = true;

Vue.use(ElementUI);
Vue.use(VueAxios, axios);

Vue.prototype.$URL = URL;
Vue.prototype.$user = user;
Vue.prototype.$prevent = prevent;
Vue.prototype.$dataObj = dataObj;
Vue.prototype.$noSign = noSign;

Vue.directive('title', {
  inserted: function (el, binding) {
    (document as any).title = el.dataset.title
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')